import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/chat',
    name: 'chat',
    component: () =>
      import(/* webpackChunkName: "chat" */ '@/views/chatViews/ChatView.vue'),
  },
  {
    path: '/spokesman/main',
    name: 'spokesman-main',
    component: () =>
      import(
        /* webpackChunkName: "chat" */ '@/views/chatViews/SpokesmanMainView.vue'
      ),
  },
  {
    path: '/spokesman/hmp',
    name: 'spokesman-hmp',
    component: () =>
      import(
        /* webpackChunkName: "chat" */ '@/views/chatViews/SpokesmanHmpView.vue'
      ),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' };
  },
});

export default router;
